<template>
  <div class="reports">
    <div class="header">MARKETING ADS</div>
    <ads-table></ads-table>
  </div>
</template>

<script>
import AdsTable from './AdsTable'
export default {
  name: 'marketing-ads',
  components: { AdsTable }
}
</script>

<style lang="scss" scoped>
.header {
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
}
</style>



// WEBPACK FOOTER //
// src/components/MarketingAds/index.vue